<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '../../../types/site'

const props = defineProps<{ block: SiteBlock }>()

const t = useSiteEditorT()

const addFaq = () => {
  props.block.data.faqs = [...(props.block.data.faqs ?? []), { question: '', answer: '' }]
}
const removeFaq = (i: number) => {
  props.block.data.faqs?.splice(i, 1)
}
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField :label="t('site.f.common.heading_optional', 'Heading (optional)')">
    <UInput
      v-model="block.data.headline"
      class="w-full"
    />
  </UFormField>
  <SiteEditorArrayItemCard
    v-for="(faq, i) in block.data.faqs ?? []"
    :key="i"
    :label="`${t('site.f.faq.item_label', 'Question')} ${i + 1}`"
    @remove="removeFaq(i)"
  >
    <UInput
      v-model="faq.question"
      :placeholder="t('site.f.faq.question', 'Question')"
      class="w-full"
    />
    <UTextarea
      v-model="faq.answer"
      :rows="3"
      :placeholder="t('site.f.faq.answer', 'Answer')"
      class="w-full"
    />
  </SiteEditorArrayItemCard>
  <UButton
    size="sm"
    variant="outline"
    color="neutral"
    icon="i-lucide-plus"
    @click="addFaq"
  >
    {{ t('site.f.faq.add_item', 'Add question') }}
  </UButton>
</template>
